"use strict";

/**
 * Handles all product listings and search pages.
 */

import Toolbox from "./toolbox";
import { itemListingConfigModifier } from "./listing-helper";
import ItemFetcherHandler from "./listing-item-fetcher";
import ItemListingListenersHandler from "./listing-listener-handler";
import ListingFilterHandler from "./listing-filter-handler";
import ListingActionsHandler from "./listing-actions";

class SelectionGuidesListing {
	init() {

		if (!document.querySelector(".generic-listing.selection-guides__listing") || !document.querySelector(".filter-bar")) {
			return;
		}

		/* Default listing overrides. */

		const _config = {
			listingItemType: "valintaopas",
			listingItemTypePlural: "valintaoppasta",
			noListingItems: '<p class="no-listing-items">Valintaoppaita ei voitu ladata.</p>'
		};

		const config = itemListingConfigModifier.modify(_config, "config");
		itemListingConfigModifier.modify({ itemsPerPage: 20 }, "state");

		itemListingConfigModifier.loadConfig();

		const itemFetcher = new ItemFetcherHandler();

		ItemListingListenersHandler.init({ itemsFetcher: itemFetcher });
		ListingFilterHandler.init();
		ListingActionsHandler.init();

		ListingFilterHandler.loadFilterSet();

		// Restore saved state (if there is one).
		ListingFilterHandler.restoreFromSessionStorage();


		function listItemClickListeners() {

			document.querySelector(config.listingSelector).addEventListener("click", (e) => {
				const clickedElement = e.target;
				// Save list state when you click listing item.
				if (clickedElement && Toolbox.closest(clickedElement, ".listing-item")) {
					ListingFilterHandler.saveToSessionStorage();
				}
			});
		}

		// Add listeners.
		ItemListingListenersHandler.addListeners([listItemClickListeners]);

	}

}

export default new SelectionGuidesListing();
